import React from 'react';

import { addStory } from 'lib/story-books';

import { ControlButton } from '.';

addStory('control-button', () => (
  <ControlButton onPress={console.log}>Control button</ControlButton>
));
